import { createFileRoute } from "@tanstack/react-router";
import { ReglerPage } from "./regler";

export const Route = createFileRoute("/es/reglas")({
  head: () => ({
    meta: [
      { title: "Reglas de los anuncios en Sellavo – texto e imágenes" },
      { name: "description", content: "Qué puedes y qué no puedes publicar en Sellavo, tanto en texto como en imágenes." },
      { property: "og:title", content: "Reglas de los anuncios en Sellavo – texto e imágenes" },
      { property: "og:description", content: "Qué puedes y qué no puedes publicar en Sellavo, tanto en texto como en imágenes." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/reglas" }],
  }),
  component: ReglerPage,
});
